export default function (context) {
    context.redirect('/Orders/Order-documents')
}
